import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { InventoryService } from '@app/services/inventory/inventory.service';
import { InventoryItemFullInformation } from '../interfaces/inventory-item.interface';

// TODO: Add error handling.
export const inventoryItemResolverResolver: ResolveFn<InventoryItemFullInformation> = (route) => {
  const inventoryItemService = inject(InventoryService);
  const inventoryId = route.paramMap.get('itemId');

  if (!inventoryId) {
    throw new Error('Inventory ID has not been supplied.');
  }

  return inventoryItemService.getInventoryItemById(inventoryId);
};
